import { getAprilApiHost, getLimepayApiHost } from 'utils/env';
import handleApiError from 'utils/handleApiError';

import { firebaseApp } from './firebase';

export type LoginRequest = {
  MerchantUserLogin: {
    merchantId: string;
    emailAddress: string;
    password: string;
  };
};

export type LoginResponse = {
  customToken: string;
  expiresAt: string;
};

export type GlobalLoginRequest = {
  email: string;
  password: string;
};

export type GlobalLoginResponse = {
  success: boolean;
  redirectUrl: string;
  error: {
    message: string;
  };
};

export type ForgotPasswordRequest = {
  email: string;
};

export type ForgotPasswordResponse = {
  success: boolean;
  redirectUrl: string;
  error: {
    message: string;
  };
};

export const login = async (tenantId: string, payload: LoginRequest) => {
  const response = await fetch(`${await getAprilApiHost()}/auth/login`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) await handleApiError(response);

  const { customToken } = await response.json();

  return loginWithToken(tenantId, customToken);
};

export const globalLogin = async (payload: GlobalLoginRequest) => {
  const response = await fetch(`${await getLimepayApiHost()}/account/api/login`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const forgotPassword = async (payload: ForgotPasswordRequest) => {
  const response = await fetch(`${await getLimepayApiHost()}/account/api/forgot-password`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const logout = async () => {
  const firebaseAuth = firebaseApp.auth();
  return firebaseAuth.signOut();
};

export const loginWithToken = async (tenantId: string, token: string) => {
  const firebaseAuth = firebaseApp.auth();
  firebaseAuth.tenantId = tenantId;
  await firebaseAuth.setPersistence('session');
  return firebaseAuth.signInWithCustomToken(token);
};
